"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _createCurrentPageReducer = _interopRequireDefault(require("./createCurrentPageReducer"));

var _createPagesReducer = _interopRequireDefault(require("./createPagesReducer"));

var _normalizeParameters2 = _interopRequireDefault(require("./normalizeParameters"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function createPaginationReducer(resourceType, options) {
  return function paginationReducer(previousState, action) {
    // TODO: Assert resourceType is present
    // TODO: Assert operationType is present
    // TODO: Assert paginationKey is present
    // TODO: Assert pageNumber is present
    // TODO: Assert pageSize is present
    if (action.meta == null || action.meta.resourceType !== resourceType || action.meta.pageNumber == null || action.meta.pageSize == null) {
      return previousState;
    }

    var currentPageReducer = (0, _createCurrentPageReducer.default)();
    var pagesReducer = (0, _createPagesReducer.default)(options);

    var _normalizeParameters = (0, _normalizeParameters2.default)(action.meta),
        _normalizeParameters$ = _normalizeParameters.paginationKey,
        paginationKey = _normalizeParameters$ === void 0 ? 'default' : _normalizeParameters$;

    var _previousState$pagina = previousState.pagination,
        previousPaginationState = _previousState$pagina === void 0 ? {} : _previousState$pagina;
    var _previousPaginationSt = previousPaginationState[paginationKey],
        previousPagination = _previousPaginationSt === void 0 ? {} : _previousPaginationSt;
    var previousCurrentPage = previousPagination.currentPage;
    var previousPages = previousPagination.pages;
    var nextCurrentPage = currentPageReducer(previousCurrentPage, action);
    var nextPages = pagesReducer(previousPages, action);
    return _objectSpread(_objectSpread({}, previousState), {}, {
      pagination: _objectSpread(_objectSpread({}, previousPaginationState), {}, (0, _defineProperty2.default)({}, paginationKey, _objectSpread(_objectSpread({}, previousPagination), {}, {
        pages: nextPages,
        currentPage: nextCurrentPage
      })))
    });
  };
}

createPaginationReducer.initialState = {
  pagination: {}
};
var _default = createPaginationReducer;
exports.default = _default;